export default {
      id: "noise-usage",
      viewBox: "0 0 15 15",
      url: "assets/" + "sprite.svg#noise-usage",
      toString: function () {
        return this.url;
      }
    }